<template>
  <v-form flat @submit.prevent>
    <global-search-autocomplete
      :results="results"
      @searchChanged="searchChanged"
    ></global-search-autocomplete>
  </v-form>
</template>

<script>
import { globalSearchService } from '@/services/global-search-service'
import GlobalSearchAutocomplete from '@/components/search/GlobalSearchAutocomplete'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import _ from 'lodash'

export default {
  components: { GlobalSearchAutocomplete },
  data() {
    return {
      results: {}
    }
  },
  methods: {
    async searchChanged(search) {
      if (!_.isEmpty(search)) {
        const response = await globalSearchService.get(MyActiveOrganization.id, {
          searchString: search
        })
        this.results = response.data
      } else {
        this.results = {}
      }
    }
  }
}
</script>
